const PREFIX = process.env.VUE_APP_ENV == "uat" ? "uat-" : "";
const PASSPORT_PREFIX =
  `https://${PREFIX}passport${
    process.env.VUE_APP_ENV == "production" ? "" : "-service"
  }` + process.env.VUE_APP_DOMAIN;
const AUTH_PREFIX =
  `https://${PREFIX}auth${
    process.env.VUE_APP_ENV == "production" ? "" : "-service"
  }` + process.env.VUE_APP_DOMAIN;
const CLOUDSTORE_PREFIX =
  `https://${PREFIX}cloud-store` + process.env.VUE_APP_DOMAIN;
const FUWU_PREFIX =
  `https://${PREFIX}expert-service` + process.env.VUE_APP_DOMAIN;
const FUWU_PLUS_PREFIX =
  `https://${PREFIX}expert-plus-service` + process.env.VUE_APP_DOMAIN;
const KUNGFU_PREFIX =
  `https://${PREFIX}kongfu-service` + process.env.VUE_APP_DOMAIN;
const SKILL_PREFIX =
  `https://${PREFIX}question-service` + process.env.VUE_APP_DOMAIN;
const PROJECT_PREFIX =
  `https://${PREFIX}project-service` + process.env.VUE_APP_DOMAIN;
const POST_PREFIX =
  `https://${PREFIX}kcell-service` + process.env.VUE_APP_PRODEGREE_DOMAIN;

const CODING_SERVICE =
  `https://${PREFIX}coding-service` + process.env.VUE_APP_DOMAIN;
const CHALLENGE_SERVICE =
  `https://${PREFIX}challenge-service` + process.env.VUE_APP_DOMAIN;
const MASTER_SERVICE =
  `https://${PREFIX}master-service` + process.env.VUE_APP_PRODEGREE_DOMAIN;
const BILL_SERVICE =
  `https://${PREFIX}bill-service` + process.env.VUE_APP_DOMAIN;
const CODING_QUESTION_SERVICE =
  `https://${PREFIX}coding-question-service` + process.env.VUE_APP_DOMAIN;
const CODING = `https://coding` + process.env.VUE_APP_DOMAIN;
const COLUMN_PREFIX =
  `https://${PREFIX}column-service` + process.env.VUE_APP_DOMAIN;
const FEEDBACK_SERVICE =
  `https://${PREFIX}feedback-service` + process.env.VUE_APP_DOMAIN;
// const GPT_SERVICE = `https://${PREFIX}gpt-service` + process.env.VUE_APP_DOMAIN;
export default {
  userInfo: `${PASSPORT_PREFIX}/api/setting/profile`,
  // https://cloud-store.jiker.vip/api/kcell/industrial-classifications/common
  authPermissions: `${AUTH_PREFIX}/api/admin/user_permissions`,
  qiniuUrl: "https://up.qiniup.com",
  qiniuConfig: `${CLOUDSTORE_PREFIX}/api/file/config`,
  qiniuToken: `${CLOUDSTORE_PREFIX}/api/file/qiniu-upload-token`,
  qiniuStore: `${CLOUDSTORE_PREFIX}/api/file/qiniu-file-store`,
  projectFile: `${PROJECT_PREFIX}/api/file/sub-file-store`,
  columnFile: `${COLUMN_PREFIX}/api/file/sub-file-store`,
  expertFile: `${FUWU_PREFIX}/api/file/sub-file-store`,

  homeworkQiniuVideo: `${FUWU_PREFIX}/api/fuwu/expert/homeworks/video`,
  homeworkIsCorrect: `${FUWU_PREFIX}/api/fuwu/expert/homeworks/wait-evaluate`,
  homework: `${FUWU_PREFIX}/api/fuwu/expert/homeworks`,
  homeworkItem: id => `${FUWU_PREFIX}/api/fuwu/expert/homeworks/${id}`,
  homeworkProjectItem: id => `${FUWU_PREFIX}/api/fuwu/expert/projects/${id}`,
  homeworkNext: `${FUWU_PREFIX}/api/fuwu/expert/homeworks/next`,
  homeworkSources: `${FUWU_PREFIX}/api/fuwu/expert/companies`,
  homeworkProjectV2IsCorrect: `${FUWU_PREFIX}/api/fuwu/v2/expert/projects/homeworks/wait-evaluate`,
  homeworkProjectV2: `${FUWU_PREFIX}/api/fuwu/v2/projects/homeworks`,
  homeworkProjectV2Item: id =>
    `${FUWU_PREFIX}/api/fuwu/v2/expert/projects/homeworks/${id}`,
  homeworkProjectV2ItemCorrect: id =>
    `${FUWU_PREFIX}/api/fuwu/v2/expert/projects/homeworks/${id}/evaluate`,
  homeworkProjectV2Grab: `${FUWU_PREFIX}/api/fuwu/v2/expert/projects/homeworks/grab`,
  homeworkProjectV2Release: `${FUWU_PREFIX}/api/fuwu/v2/expert/projects/homeworks/release`,

  recordMyCorrect: `${FUWU_PREFIX}/api/fuwu/expert/homeworks/evaluated`,
  recordProjectV2: `${FUWU_PREFIX}/api/fuwu/v2/expert/projects/homeworks`,

  wallet: `${FUWU_PREFIX}/api/fuwu/expert/wallets`,
  walletBalance: `${FUWU_PREFIX}/api/fuwu/expert/wallets/balance`,
  walletIncome: id => `${FUWU_PREFIX}/api/fuwu/expert/wallets/income/${id}`,
  walletWithdrawal: id =>
    `${FUWU_PREFIX}/api/fuwu/expert/wallets/withdrawals/${id}`,

  settingFile: `${FUWU_PREFIX}/api/file/sub-file-store`,
  settingWithdrawal: `${FUWU_PREFIX}/api/fuwu/expert/banks`,
  settingWithdrawalItem: id => `${FUWU_PREFIX}/api/fuwu/expert/banks/${id}`,
  settingWithdrawalUser: `${FUWU_PREFIX}/api/fuwu/expert/banks/users`,
  settingWithdrawalAuto: id =>
    `${FUWU_PREFIX}/api/fuwu/expert/banks/${id}/switch_automatic_cash`,
  settingProfiles: `${FUWU_PREFIX}/api/fuwu/v2/setting/profiles`,
  settingRealnameVerifies: `${FUWU_PREFIX}/api/fuwu/v2/setting/realname-verifies`,
  settingStages: `${FUWU_PREFIX}/api/fuwu/v2/setting/stages`,

  student: `${KUNGFU_PREFIX}/api/fuwu/study-paths`,
  studentItem: id => `${KUNGFU_PREFIX}/api/fuwu/study-paths/${id}`,
  studentItemState: id => `${KUNGFU_PREFIX}/api/fuwu/study-paths/${id}/status`,
  studentItemTask: id => `${KUNGFU_PREFIX}/api/fuwu/study-paths/${id}/tasks`,
  studentItemTaskItem: (id, taskId) =>
    `${KUNGFU_PREFIX}/api/fuwu/study-paths/${id}/tasks/${taskId}`,
  studentItemTaskItemSort: (id, taskId) =>
    `${KUNGFU_PREFIX}/api/fuwu/study-paths/${id}/tasks/${taskId}/sort`,
  studentItemTaskItemState: (id, taskId) =>
    `${KUNGFU_PREFIX}/api/fuwu/study-paths/${id}/tasks/${taskId}/status`,
  course: `${KUNGFU_PREFIX}/api/fuwu/courses`,
  courseItem: id => `${KUNGFU_PREFIX}/api/fuwu/courses/${id}`,
  courseCategories: `${KUNGFU_PREFIX}/api/fuwu/courses-categories`,
  kongfuProject: `${KUNGFU_PREFIX}/api/fuwu/projects`,
  kongfuProjectItem: id => `${KUNGFU_PREFIX}/api/fuwu/projects/${id}`,
  kongfuProjectJobs: `${KUNGFU_PREFIX}/api/fuwu/projects-all-jobs`,

  project: `${PROJECT_PREFIX}/api/fuwu/projects`,
  projectItem: id => `${PROJECT_PREFIX}/api/fuwu/projects/${id}`,
  projectTask: `${PROJECT_PREFIX}/api/fuwu/project-tasks`,
  projectTaskItem: id => `${PROJECT_PREFIX}/api/fuwu/project-tasks/${id}`,

  skillSkillIdKnowledge: id =>
    `${SKILL_PREFIX}/api/fuwu/skills/${id}/knowledge`,
  skillTask: `${SKILL_PREFIX}/api/fuwu/skill-question-tasks`,
  skillTaskItem: id => `${SKILL_PREFIX}/api/fuwu/skill-question-tasks/${id}`,
  skillTopic: `${SKILL_PREFIX}/api/fuwu/skill-questions`,
  skillTopicItem: id => `${SKILL_PREFIX}/api/fuwu/skill-questions/${id}`,
  skillProofreadTasks: `${SKILL_PREFIX}/api/fuwu/skill-question-verify-tasks`,
  skillProofreadTaskItem: id =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-verify-tasks/${id}`,
  skillProofreadTasksMy: `${SKILL_PREFIX}/api/fuwu/skill-question-verify-tasks/my`,
  skillProofreadTaskAssign: id =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-verify-tasks/${id}/grab`,
  skillProofreadTaskPass: id =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-verify-tasks/${id}/pass`,
  skillProofreadQuestionNext: id =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-verify-tasks/${id}/questions/next`,
  skillProofreadQuestionStatus: id =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-verify-tasks/${id}/question-statuses`,
  skillProofreadQuestionVerify: (id, question_id) =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-verify-tasks/${id}/questions/${question_id}/verify`,
  skillProofreadQuestionItem: (id, question_id) =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-verify-tasks/${id}/questions/${question_id}`,
  //question-service 1.4
  skillQuestionReviewTaskTypeQuestions: type =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-review-task/type/${type}/questions`,
  skillQuestionReviewTaskTypeQuestionPass: (type, id) =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-review-task/type/${type}/questions/${id}/pass`,
  skillQuestionReviewTaskTypeQuestionReject: (type, id) =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-review-task/type/${type}/questions/${id}/reject`,
  skillQuestionReviewTaskQuestionId: id =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-review-task/questions/${id}`,
  skillQuestionReviewTaskTypeQuestionsMy: type =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-review-task/type/${type}/questions/my`,
  skillQuestionReviewTaskTypeStatistics: type =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-review-task/type/${type}/statistics`,
  //题目抽检 skill-question-spot-check/tasks/{taskId}/questions/{id}
  skillSpotCheckTask: `${SKILL_PREFIX}/api/fuwu/skill-question-spot-check/tasks`,
  skillSpotCheckQuestion: taskId =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-spot-check/tasks/${taskId}/questions`,
  skillSpotCheck: (id, taskId) =>
    `${SKILL_PREFIX}/api/fuwu/skill-question-spot-check/tasks/${taskId}/questions/${id}/spot-check`,

  kcellSkills: `${CLOUDSTORE_PREFIX}/api/kcell/skills/all`,
  kcellIndustry: `${CLOUDSTORE_PREFIX}/api/kcell/industrial-classifications/common`,
  kcellPositionsAll: `${CLOUDSTORE_PREFIX}/api/kcell/positions/all`,
  kcellPositionsSkillModel: id =>
    `${CLOUDSTORE_PREFIX}/api/kcell/positions/${id}/skill-model`,

  postTask: `${POST_PREFIX}/api/jiker/fuwu/skill-model-tasks`,
  skillBuildTasks: `${POST_PREFIX}/api/jiker/fuwu/stack-build-tasks`,
  skillKnowledgeInfo: id =>
    `${POST_PREFIX}/api/jiker/fuwu/stack-build-tasks/${id}/knowledge-tree`,
  skillKnowledgeContent: (id, knowledgePointId) =>
    `${POST_PREFIX}/api/jiker/fuwu/stack-build-tasks/${id}/knowledge-point/${knowledgePointId}/content`,
  skillKnowledgeVerify: (id, knowledgePointId) =>
    `${POST_PREFIX}/api/jiker/fuwu/stack-build-tasks/${id}/knowledge-point/${knowledgePointId}/verify`,
  chatGpt: `${POST_PREFIX}/api/jiker/fuwu/gpt/chat`,
  chatGptDialog: `${POST_PREFIX}/api/jiker/fuwu/gpt/dialog`,
  chatGptFiles: `${POST_PREFIX}/api/jiker/fuwu/gpt/sub-files`,
  chatGptKiMiFiles: `${POST_PREFIX}/api/jiker/fuwu/gpt/kimi-files`,
  //
  postTaskItem: id => `${POST_PREFIX}/api/jiker/fuwu/skill-model-tasks/${id}`,
  postGroupStacks: id =>
    `${POST_PREFIX}/api/jiker/fuwu/skill-models/${id}/group-stacks`,
  postSkillLevels: id =>
    `${POST_PREFIX}/api/jiker/fuwu/skill-models/${id}/levels`,

  codingFileSearch: `${CODING_SERVICE}/api/projects`,
  codingFileDetail: id => `${CODING_SERVICE}/api/project/${id}`,

  expertConst: `${FUWU_PLUS_PREFIX}/api/web/expert/assistants/common-data`,
  expertCreate: `${FUWU_PLUS_PREFIX}/api/web/expert/assistants/apply`,
  expertLatest: `${FUWU_PLUS_PREFIX}/api/web/expert/assistants/latest`,
  expertIndustryJobs: `${FUWU_PLUS_PREFIX}/api/web/expert/assistants/industry-jobs`,

  //挑战
  challengeFile: `${CHALLENGE_SERVICE}/api/file/sub-file-store`,
  challengeTasks: `${CHALLENGE_SERVICE}/api/fuwu/challenge-tasks`,
  challengeTaskId: id => `${CHALLENGE_SERVICE}/api/fuwu/challenge-tasks/${id}`,
  myChallenge: `${CHALLENGE_SERVICE}/api/fuwu/my-challenges`,
  myChallengeId: id => `${CHALLENGE_SERVICE}/api/fuwu/my-challenges/${id}`,
  myChallengeIdAnswerAll: id =>
    `${CHALLENGE_SERVICE}/api/fuwu/my-challenges/${id}/answers/all`,
  myChallengeIdAnswerId: (challengeId, answerId) =>
    `${CHALLENGE_SERVICE}/api/fuwu/my-challenges/${challengeId}/answers/${answerId}`,
  myChallengeIdAnswers: id =>
    `${CHALLENGE_SERVICE}/api/fuwu/my-challenges/${id}/answers`,
  myChallengeTaskAll: `${CHALLENGE_SERVICE}/api/fuwu/my-challenge-tasks/all`,
  myChallengeContent: id =>
    `${CHALLENGE_SERVICE}/api/fuwu/my-challenges/${id}/content`,
  myChallengeAudit: id =>
    `${CHALLENGE_SERVICE}/api/fuwu/my-challenges/${id}/submit-audit`,
  myChallengeAnswerTip: id =>
    `${CHALLENGE_SERVICE}/api/fuwu/my-challenges/${id}/answer-tip`,
  myChallengeEvaluateRequire: id =>
    `${CHALLENGE_SERVICE}/api/fuwu/my-challenges/${id}/evaluate-require`,

  //能力
  abilityList: `${FUWU_PREFIX}/api/fuwu/v2/ability/certify`,
  mytask: `${FUWU_PREFIX}/api/fuwu/v2/expert/ability/certify`,
  grabOrder: `${FUWU_PREFIX}/api/fuwu/v2/expert/ability/certify/grab`,
  releaseOrder: `${FUWU_PREFIX}/api/fuwu/v2/expert/ability/certify/release`,
  evaluate: id =>
    `${FUWU_PREFIX}/api/fuwu/v2/expert/ability/certify/${id}/evaluate`,
  evaluateDetail: id =>
    `${FUWU_PREFIX}/api/fuwu/v2/expert/ability/certify/${id}`,
  abilityCategory: `${MASTER_SERVICE}/api/fuwu/ability/category?with_model = all`,

  //挑战作品
  challengesWork: `${FUWU_PREFIX}/api/fuwu/v2/challenges/works`,
  challengeWorksId: id =>
    `${FUWU_PREFIX}/api/fuwu/v2/expert/challenges/works/${id}`,
  challengeWorksEvaluate: id =>
    `${FUWU_PREFIX}/api/fuwu/v2/expert/challenges/works/${id}/evaluate`,
  myChallengesWork: `${FUWU_PREFIX}/api/fuwu/v2/expert/challenges/works`,
  challengeWorkGrab: `${FUWU_PREFIX}/api/fuwu/v2/expert/challenges/works/grab`,
  challengeWorkRelease: `${FUWU_PREFIX}/api/fuwu/v2/expert/challenges/works/release`,
  challengeAttachment: id =>
    `${CHALLENGE_SERVICE}/api/fuwu/my-challenges/${id}/attachment`,
  challengeDuplicateCheck: id =>
    `${CHALLENGE_SERVICE}/api/fuwu/challenges/works/check-duplicate/${id}`,
  challengeDuplicateDetail: id =>
    `${CHALLENGE_SERVICE}/api/fuwu/challenges/works/check-duplicate/${id}/detail`,
  //feature/v2.0.67/bill-service-v1.0  提现
  financeIncomes: `${BILL_SERVICE}/api/fuwu/finance-incomes`,
  financeWithdraws: `${BILL_SERVICE}/api/fuwu/finance-withdraws`,
  balance: `${BILL_SERVICE}/api/fuwu/balance`,
  questionTest: `${CODING_SERVICE}/api/coding/cases/run`,
  // 出题任务
  codingQuestionTask: `${CODING_QUESTION_SERVICE}/api/fuwu/question-tasks`,
  myQuestion: `${CODING_QUESTION_SERVICE}/api/fuwu/questions/my`,
  examTags: `${CODING_QUESTION_SERVICE}/api/service-admin/exam-tags`,
  taskInfo: id => `${CODING_QUESTION_SERVICE}/api/fuwu/question-tasks/${id}`,
  programQuestion: `${CODING_QUESTION_SERVICE}/api/fuwu/questions`,
  programInfo: id => `${CODING_QUESTION_SERVICE}/api/fuwu/questions/${id}`,
  questionCase: `${CODING_QUESTION_SERVICE}/api/coding/cases/run`,
  questionExamTags: `${CODING_QUESTION_SERVICE}/api/fuwu/exam-tags`,
  codingImageList: `${CODING}/api/code/warehouses`,
  teacherList: `${FUWU_PLUS_PREFIX}/api/web/expert/teachers`,
  // /api/fuwu/questions/{id}
  // examTags: `${CODING_QUESTION_SERVICE}/api/service-admin/exam-tags`,
  //专栏
  columns: `${COLUMN_PREFIX}/api/fuwu/columns`,
  columnsInfo: id => `${COLUMN_PREFIX}/api/fuwu/columns/${id} `,
  columnsPrecis: id => `${COLUMN_PREFIX}/api/fuwu/columns/${id}/contents `,
  columnsAttachment: (id, nodeId) =>
    `${COLUMN_PREFIX}/api/fuwu/columns/${id}/contents/${nodeId}/attachment `,
  columnsNodeContent: (id, nodeId) =>
    `${COLUMN_PREFIX}/api/fuwu/columns/${id}/contents/${nodeId} `,
  columnsNodeContentVerify: (id, nodeId) =>
    `${COLUMN_PREFIX}/api/fuwu/columns/${id}/contents/${nodeId}/verify `,
  // api/fuwu/columns/3/contents
  // home页数据
  dataQuestionReview1: `${SKILL_PREFIX}/api/fuwu/expert-tasks/skill-question-review/1`,
  dataQuestionReview2: `${SKILL_PREFIX}/api/fuwu/expert-tasks/skill-question-review/2`,
  dataCodingReview: `${CODING_QUESTION_SERVICE}/api/fuwu/expert-tasks/questions`,
  dataQuestionCheck: `${SKILL_PREFIX}/api/fuwu/expert-tasks/skill-question-spot-check`,

  dataQuestionSkill: `${SKILL_PREFIX}/api/fuwu/expert-tasks/skill-questions`,
  dataProjectCreate: `${PROJECT_PREFIX}/api/fuwu/expert-tasks/projects`,
  dataChallengeCreate: `${CHALLENGE_SERVICE}/api/fuwu/expert-tasks/challenges`,
  dataHomework: `${PROJECT_PREFIX}/api/fuwu/expert-tasks/homeworks`,
  dataChallengeWork: `${CHALLENGE_SERVICE}/api/fuwu/expert-tasks/challenge-works`,
  dataTranslateQuestion: `${SKILL_PREFIX}/api/fuwu/expert-tasks/skill-question-verify`,
  dataWiki: `${POST_PREFIX}/api/jiker/fuwu/expert-tasks/knowledge-wiki`,
  dataColumn: `${COLUMN_PREFIX}/api/fuwu/expert-tasks/columns`,
  // 反馈
  topicList: `${FEEDBACK_SERVICE}/api/fuwu/project-applications`
  // gptDialog: `${GPT_SERVICE}/api/jiker/fuwu/gpt/dialog`,
  // gptChat: `${GPT_SERVICE}/api/jiker/fuwu/gpt/chat`,
  // gptInfo: `${GPT_SERVICE}/api/jiker/fuwu/gpt/gpts`,
  // gptApps: `${GPT_SERVICE}/api/jiker/fuwu/gpt/apps`
};
